import { libraryManagedConfig } from '../../../../../config';
import { http } from '../../../../../api/axios';

export const PAGE = 0;
export const PAGE_SIZE = 10000;
export const DEFAULT_SORTBY = 'custom';

export type Payload = {
    productIdsToSortPosition: { [key: string]: number };
    productGroupId: string;
};

export const saveLibraryManagedProductGroupSorting = async (data: Payload) => {
    const { productIdsToSortPosition, productGroupId } = data;
    return http.put(
        libraryManagedConfig().endpointProductGroupProductsSorting,
        {
            productIdsToSortPosition
        },
        {
            pathParams: { productGroupId }
        }
    );
};
